import React from 'react';
import { ContentCenter } from './ContentCenter';

import { LibraryType } from './ContentCenter.types';

export const ContentModuleLibrary: React.FC = () => (
  <ContentCenter libraryType={'contentModuleLibrary' as LibraryType} />
);
